import React from 'react';
import dayjs from 'dayjs';
import { T } from '@transifex/react';

import { useUser } from 'src/app/User.store';
import { PageHeading } from 'src/components/layout/PageHeading';

import HomeContent from './HomeContent';
import { QuickActions } from './QuickActions';

const getGreeting = (hour: number) => {
  if (hour < 12) return <T _str="Good morning" />;
  if (hour < 18) return <T _str="Good afternoon" />;
  return <T _str="Good evening" />;
};

const Greeting = () => {
  const { data: user } = useUser();
  const greeting = getGreeting(dayjs().hour());

  return (
    <PageHeading
      title={
        user?.anonymous || !user?.name ? (
          greeting
        ) : (
          <>
            {greeting}, {user.name}
          </>
        )
      }
      subtitle={
        <T _str="Manage your municipal waste services and tracking here" />
      }
    />
  );
};

const Exact = () => {
  return (
    <div className="wh-ui block min-h-0 min-w-0 flex-1 overflow-y-auto">
      <div className="mx-auto flex w-full max-w-[1200px] flex-col gap-10 px-6 py-8 lg:px-0">
        <Greeting />
        <HomeContent />
        <QuickActions />
      </div>
    </div>
  );
};

export default Exact;
